import UserAPICall from "src/service/AdminAPICalls/UserAPICall";
import BaseRepository from "../BaseRepository";


class UserRepository extends BaseRepository {
  //Get
  getUserList = async (params) => {
    return await new UserAPICall().getUserList(params);
  };
  getUserDetail = async (userId) => {
    return await new UserAPICall().getUserDetail(userId);
  };
  getUserAcctList = async (userId) => {
    return await new UserAPICall().getUserAcctList(userId);
  };
  getUserSearchAcctList = async (params) => {
    return await new UserAPICall().getUserSearchAcctList(params);
  };

  deleteUsers = async (params) => {
    return await new UserAPICall().deleteUsers(params);
  };
  exportUserList = async () => {
    return await new UserAPICall().exportUserList();
  };
  emailUserList = async (params) => {
    return await new UserAPICall().emailUserList(params);
  };
  addUser = async (params) => {
    return await new UserAPICall().addUser(params);
  };
  updateUserAcctSponsorship = async (params) => {
    return await new UserAPICall().updateUserAcctSponsorship(params);
  };
  updateUnsponsorUserAcct = async (params) => {
    return await new UserAPICall().updateUnsponsorUserAcct(params);
  }

  updateUserDetail = async (params) => {
    return await new UserAPICall().updateUserDetail(params);
  };
  checkUserEmail = async (params) => {
    return await new UserAPICall().checkUserEmail(params);
  };
  updateUserActiveStatus = async (params) => {
    return await new UserAPICall().updateUserActiveStatus(params);
  };
  searchSponsorAccounts = async (params) => {
    return await new UserAPICall().searchSponsorAccounts(params);
  };
  updateUserRoles = async (params) => {
    return await new UserAPICall().updateUserRoles(params);
  }

}

export default UserRepository;